// extracted by mini-css-extract-plugin
export default {"EditHealthCheckSettingsDialog":"EditHealthCheckSettingsDialog_EditHealthCheckSettingsDialog__xepiU"};